@if (banner(); as kind) {
  <div class="connection-banner" [class]="'connection-banner--' + kind" role="status">
    <svg class="banner-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      @switch (kind) {
        @case ('offline') { <path d="M3 3l18 18M7 18a4.5 4.5 0 0 1-.6-8.96M10.1 6.2A6 6 0 0 1 18 10a4 4 0 0 1 2.2 7.3M7 18h10" /> }
        @case ('realtime') { <path d="M20 12a8 8 0 1 1-2.34-5.66M20 4v5h-5" /> }
        @default { <path d="M5 12l5 5L20 7" /> }
      }
    </svg>
    <span class="banner-message">{{ ('connection.' + kind) | translate }}</span>
    @if (kind === 'realtime') {
      <button type="button" class="banner-action" (click)="reload()">{{ 'common.reload' | translate }}</button>
    }
    @if (kind !== 'offline') {
      <button type="button" class="banner-close" (click)="connectivity.dismiss()" [attr.aria-label]="'a11y.close' | translate">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
    }
  </div>
}
